var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "file-invoice", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _vm.pending > 0
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-5",
                  attrs: { type: "warning", text: "", dense: "" },
                },
                [
                  _vm._v(" Tenés "),
                  _c("b", [_vm._v(_vm._s(_vm.pending))]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.pending == 1
                          ? "recibo pendiente"
                          : "recibos pendientes"
                      ) +
                      " de firma. Abrí cada recibo, leelo y firmalo. "
                  ),
                ]
              )
            : _vm._e(),
          _c("v-card", { staticClass: "mb-5 px-4 py-6" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-3" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.years,
                      label: "Año",
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.period_year,
                      callback: function ($$v) {
                        _vm.period_year = $$v
                      },
                      expression: "period_year",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-3" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.types,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Tipo",
                      clearable: "",
                      "hide-details": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-md-6",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.loadList },
                    },
                    [_vm._v("Buscar")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "lc-loose" },
            [
              _c("v-data-iterator", {
                attrs: {
                  items: _vm.loading ? [] : _vm.list,
                  loading: _vm.loading,
                  "hide-default-footer": _vm.loading,
                  "items-per-page": 15,
                  "footer-props": { itemsPerPageOptions: [5, 10, 15, 50, -1] },
                },
                scopedSlots: _vm._u([
                  {
                    key: "loading",
                    fn: function () {
                      return [_c("ListSkeletonRows", { attrs: { count: 4 } })]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "div",
                          { staticClass: "lc-list" },
                          _vm._l(props.items, function (payslip) {
                            return _c(
                              "div",
                              {
                                key: payslip.id,
                                staticClass: "lc-item mp-row",
                              },
                              [
                                _c("div", { staticClass: "lc-main mp-main" }, [
                                  _c("div", { staticClass: "lc-info" }, [
                                    _c("div", { staticClass: "lc-title" }, [
                                      _vm._v(_vm._s(_vm.periodTitle(payslip))),
                                    ]),
                                    _c("div", { staticClass: "lc-sub" }, [
                                      _vm._v(
                                        _vm._s(
                                          payslip.type ? payslip.type.name : ""
                                        ) +
                                          " · Pago " +
                                          _vm._s(
                                            _vm.formatDate(payslip.payment_date)
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "lc-meta" }, [
                                  _c(
                                    "div",
                                    { staticClass: "lc-meta-col mp-col-date" },
                                    [
                                      payslip.signed_at
                                        ? [
                                            _vm._v(
                                              "Firmado " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    payslip.signed_at
                                                  )
                                                )
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              "Publicado " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    payslip.published_at
                                                  )
                                                )
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "mp-col-status" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            small: "",
                                            color:
                                              _vm.statusChip(payslip).color,
                                            "text-color":
                                              _vm.statusChip(payslip)
                                                .text_color,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.statusChip(payslip).name
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "lc-actions mp-col-actions",
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                            loading:
                                                              _vm.opening ==
                                                              payslip.id,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.openFile(
                                                                payslip
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "blue",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-file-pdf-box"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [_c("span", [_vm._v("Ver recibo")])]
                                      ),
                                      payslip.status != _vm.signed
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                disabled:
                                                  payslip.status !=
                                                  _vm.published,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "ml-2",
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "mp-sign-btn",
                                                                attrs: {
                                                                  small: "",
                                                                  depressed: "",
                                                                  color:
                                                                    "primary",
                                                                  disabled:
                                                                    payslip.status ==
                                                                    _vm.published,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.openSign(
                                                                        payslip
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      left: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-draw-pen"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " Firmar "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Abrí el recibo para poder firmarlo"
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              staticClass: "ml-2 mp-sign-btn",
                                              attrs: {
                                                small: "",
                                                outlined: "",
                                                color: "green",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.openSign(payslip)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    left: "",
                                                  },
                                                },
                                                [_vm._v("mdi-check-decagram")]
                                              ),
                                              _vm._v(" Ver firma "),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    },
                  },
                  {
                    key: "no-data",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "lc-empty" }, [
                          _vm._v(
                            "No tenés recibos para los filtros seleccionados."
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ModalSignPayslip", {
        attrs: {
          dialog: _vm.dialog_sign,
          payslip: _vm.selected_payslip,
          "signature-loader": _vm.signatureLoader,
        },
        on: {
          updateDialog: (value) => (_vm.dialog_sign = value),
          signed: _vm.loadList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }